import { useCoreDispatch, useCoreSelector } from "../../redux/config.js";
import { selecModalView } from "../../redux/modal-view/selectors.js";
import { hideModalView } from "../../redux/modal-view/thunks/hide-modal-view.js";
import { revealModalView } from "../../redux/modal-view/thunks/reveal-modal-view.js";
import { updateModalView } from "../../redux/modal-view/thunks/update-modal-view.js";
import { useState } from "react";
//#region src/presentation/hooks/use-modal-view.ts
var useModalView = () => {
	const dispatch = useCoreDispatch();
	const [modalViewId, setModalViewId] = useState("");
	const modalView = useCoreSelector(selecModalView(modalViewId));
	const hide = async () => {
		await dispatch(hideModalView({ id: modalViewId }));
	};
	const reveal = async (modalView) => {
		const result = await dispatch(revealModalView({ ...modalView }));
		if (result?.payload) setModalViewId(result.payload.id ?? "");
	};
	const update = async (modalView) => {
		await dispatch(updateModalView({
			...modalView,
			id: modalViewId
		}));
	};
	return [
		reveal,
		modalView,
		update,
		hide
	];
};
//#endregion
export { useModalView };

//# sourceMappingURL=use-modal-view.js.map